import { useCallback, useState } from 'react';

export const useForceUpdate = () => {
  const [_value, setValue] = useState({});
  return useCallback(() => setValue({}), []);
};
